/**
 * @generated SignedSource<<d01d011572e18f8ba9aac0ff9f16ee65>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type EditPipelinePageCancelBuildMutation$variables = {
  buildLocator: string;
};
export type EditPipelinePageCancelBuildMutation$data = {
  readonly cancelBuild: {
    readonly id: number | null | undefined;
  } | null | undefined;
};
export type EditPipelinePageCancelBuildMutation = {
  response: EditPipelinePageCancelBuildMutation$data;
  variables: EditPipelinePageCancelBuildMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "buildLocator"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "buildLocator",
    "variableName": "buildLocator"
  },
  {
    "kind": "Literal",
    "name": "input",
    "value": {}
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "EditPipelinePageCancelBuildMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "cancelBuild",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "EditPipelinePageCancelBuildMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Build",
        "kind": "LinkedField",
        "name": "cancelBuild",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "_id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "9e0f56738bb88116fc0bd2aff3fbf1b8",
    "id": null,
    "metadata": {},
    "name": "EditPipelinePageCancelBuildMutation",
    "operationKind": "mutation",
    "text": "mutation EditPipelinePageCancelBuildMutation(\n  $buildLocator: String!\n) {\n  cancelBuild(buildLocator: $buildLocator, input: {}) {\n    id\n    _id\n  }\n}\n"
  }
};
})();

(node as any).hash = "f03cc7acf783ebfd9eebd61a23ef48fb";

export default node;
